import { AIGeneratedField } from '@/redux/slices/formAIGenerationSlice'
import { BuildFieldFn, BuiltFieldAttributes, FieldBuilderParams } from './baseFieldBuilder'

export default function dimensionsBuilder({
  rawField,
  scene,
  buildField,
}: FieldBuilderParams): Partial<BuiltFieldAttributes> {
  return {
    dimensions: buildTableDimensions(rawField.dimensions, scene, buildField),
  }
}

const DIMENSIONS_FIELD_TYPES = [
  'TextField',
  'TextArea',
  'DropDown',
  'CheckBox',
  'EmailField',
  'DateTimeField',
  'AttachmentField',
  'MobileField',
  'IdCardField',
  'NumberField',
  'TimeField',
]

type ArrayDimensions = Extract<NonNullable<AIGeneratedField['dimensions']>, { length: number }>

type DimensionFieldAttributes = BuiltFieldAttributes & { enableDimensionCalculation?: boolean }

function buildTableDimensions(
  rawDimensions: AIGeneratedField['dimensions'],
  scene: string,
  buildField: BuildFieldFn
): DimensionFieldAttributes[] {
  let dimensions: DimensionFieldAttributes[] | undefined

  if (Array.isArray(rawDimensions)) {
    dimensions = (rawDimensions as ArrayDimensions)
      .filter(dimension => DIMENSIONS_FIELD_TYPES.includes(dimension.type))
      .map((rawDimension, index) => {
        const dimension: DimensionFieldAttributes = {
          ...buildField({ rawField: rawDimension as AIGeneratedField, scene }),
          position: index,
        }
        if (dimension.type === 'NumberField') {
          dimension.enableDimensionCalculation = false
        }
        return dimension
      })
  }

  if (!dimensions?.length) {
    dimensions = [
      { type: 'TextField', label: '项目一', position: 0 } as DimensionFieldAttributes,
      { type: 'TextField', label: '项目二', position: 1 } as DimensionFieldAttributes,
      { type: 'TextField', label: '项目三', position: 2 } as DimensionFieldAttributes,
    ]
  }

  return dimensions
}
